import { ReviewBaseMixin } from './review_base_mixin.js';

class ReviewPlain extends ReviewBaseMixin(Object) {}

export { ReviewPlain };
